import React from "react";
import { SiGooglemaps } from "react-icons/si";
import { BsTelephoneFill, BsYoutube } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { RiInstagramFill } from "react-icons/ri";

export default function Footer() {
  return (
    <>
      <div
        className="mx-auto space-y-10 lg:space-y-0 p-12 lg:h-72 text-center text-white lg:grid lg:grid-cols-3 lg:divide-x lg:divide-black flex flex-col items-center justify-center 2xl:px-32 2xl:py-0"
        style={{
          backgroundColor: "#1B5FC1",
        }}
      >
        <div className="space-y-1 lg:space-y-0 text-center flex flex-col items-center justify-center lg:mr-2">
          <a
            href="https://www.google.com/maps/place/Klinik+Mora+Medika/@-6.2494832,107.0724863,17z/data=!4m15!1m8!3m7!1s0x2e698fa615c115a1:0x40033340d7610121!2sKlinik+Mora+Medika!8m2!3d-6.2494832!4d107.0724863!10e1!16s%2Fg%2F1pzvl3lbc!3m5!1s0x2e698fa615c115a1:0x40033340d7610121!8m2!3d-6.2494832!4d107.0724863!16s%2Fg%2F1pzvl3lbc?entry=ttu"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SiGooglemaps className="cursor-pointer hover:text-green-800 text-3xl sm:text-4xl lg:text-5xl text-center text-green-600 font-bold" />
          </a>

          <h3 className="text-lg sm:text-2xl font-bold ">Alamat</h3>
          <p>
            Perum Taman Puri Cendana No.1, Tridaya Sakti, Kec. Tambun Sel.,
            Kabupaten Bekasi, Jawa Barat 17510
          </p>
        </div>

        <div className="space-y-1 lg:space-y-0 text-center flex flex-col items-center justify-center">
          <BsTelephoneFill className="text-3xl sm:text-4xl lg:text-5xl text-center text-green-600 font-bold" />
          <h3 className="text-lg sm:text-2xl font-bold">No. Telp</h3>
          <p>081318343744</p>
        </div>

        <div className="space-y-1 lg:space-y-0 text-center flex flex-col items-center justify-center">
          <MdEmail className="text-3xl sm:text-4xl lg:text-5xl text-center text-green-600 font-bold" />
          <h3 className="text-lg sm:text-2xl font-bold">Email</h3>
          <p>klinikmora.tpc@gmail.com</p>
        </div>
      </div>
      <div className="space-y-12 lg:space-y-0 my-24 mx-auto w-5/6 lg:mx-0 lg:w-auto flex flex-col lg:flex-row lg:justify-between lg:px-32 lg:my-24 ">
        <div className="space-y-10">
          <img className="w-40" src="assets/logo.png" alt="" />
          <p className="text-gray-500 text-justify">
            Klinik Mora Medika menjadi bagian dari <br />
            masyarakat yang melayani dengan sepenuh hati
          </p>
        </div>
        <div className="text-3xl sm:text-4xl flex space-x-1">
          <a
            href="https://www.instagram.com/klinikmoramedika/?igshid=MzRlODBiNWFlZA%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
          >
            <RiInstagramFill className="text-blue-500 cursor-pointer hover:text-blue-800" />
          </a>

          <BsYoutube className="text-blue-500 cursor-pointer hover:text-blue-800" />
        </div>
      </div>
      <hr />

      <div>
        <p className="text-center p-6">Copyright © 2023 Klinik Mora Medika</p>
      </div>
    </>
  );
}
